import { getAuth, signInWithEmailAndPassword } from "firebase/auth";

// Initialize Firebase Auth
const auth = getAuth();

export const signIn = (email, password) => {
  return signInWithEmailAndPassword(auth, email, password);
};
